import { useState } from 'react';
import { useMutation } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import { Button, LoadingState } from '@/component';
import { useMyDevices } from '@/hook';
import { formatReceiptDate } from '@/lib/time';
import { toResult } from '@/lib/result-adapter';

/** Settings, TVs: the TVs paired to this account, each with Unpair. A TV is paired from a phone in its room. */
export function TvsTab() {
  const devices = useMyDevices();
  const unpair = useMutation(api.devices.unpair);
  const [error, setError] = useState<string | null>(null);

  if (!devices) return <LoadingState />;

  async function remove(deviceId: string) {
    setError(null);
    const result = await toResult(() => unpair({ deviceId }));
    if (!result.ok) setError(`Couldn't unpair it: ${result.error.message}`);
  }

  return (
    <div className="mt-10 max-w-[820px]">
      <h2 className="border-b border-line pb-3 text-[15px] font-semibold">Your screens</h2>
      {devices.length === 0 ? (
        <p className="py-5 text-sm text-mute">No screens yet. Make one yours from the Aeon app while you're in its room.</p>
      ) : (
        devices.map((device) => (
          <div key={device.deviceId} className="flex items-center justify-between gap-[18px] border-b border-stripeA py-4">
            <div className="min-w-0">
              <div className="truncate text-[15px] font-semibold tracking-[-0.01em]">{device.name}</div>
              <div className="mt-[2px] text-[13px] text-mute">Paired {formatReceiptDate(device.pairedAt)}</div>
            </div>
            <Button variant="outline" size="sm" onClick={() => void remove(device.deviceId)}>
              Unpair
            </Button>
          </div>
        ))
      )}
      {error && <p className="mt-3 text-[13px] text-down">{error}</p>}
    </div>
  );
}
